import React, { useState, useEffect } from "react";
import "./style.css";
import TextToQuoteCard from "../TextToQuoteCard";
import CoverPathMass from "../CoverPathMass";
import PublicQuoteCard from "../PublicQuoteCard";
import Modal from "react-modal";

const customStylesModal = {
  content: {
    padding: "2px 2px",
    background: "transparent",
    overflowX: "auto",
    border: "0px"
  }
};

function QuoteModule() {
  const [formData, setFormData] = useState({
    showCoverPathMass: false,
    showIcons: true,
    showFastQuote: false,
    showTextQuote: false
  });

  useEffect(() => {
    console.log("Quote Module Mounted");
  }, []);

  const resetViews = (overrides = {}) => {
    setFormData({
      showCoverPathMass: false,
      showIcons: false,
      showFastQuote: false,
      showTextQuote: false,
      ...overrides
    });
  };

  const returnToModule = () => {
    resetViews({ showIcons: true });
  };

  const redirect = (url) => {
    console.log("redirecting to: " + url);
    window.open(url, "", "width=800, height=800, top=+200, left=+400");
  };

  const toggleFastQuote = (e) => {
    e.preventDefault();
    if (formData.showFastQuote) {
      resetViews({ showIcons: true });
    } else {
      resetViews({ showFastQuote: true });
    }
  };

  const toggleTextQuote = (e) => {
    e.preventDefault();
    if (formData.showTextQuote) {
      resetViews({ showIcons: true });
    } else {
      resetViews({ showTextQuote: true });
    }
  };

  return (
    <div>
      <div
        className="card"
        style={{
          border: "0px",
          backgroundColor: "transparent",
          height: "100%",
          overflow: "auto"
        }}
      >
        <div className="card-body" style={{ padding: "0px" }}>
          <Modal
            isOpen={formData.showFastQuote}
            onRequestClose={(e) => toggleFastQuote(e)}
            style={customStylesModal}
          >
            <button
              style={{
                width: "12.5%",
                marginLeft: "87.5%",
                textAlign: "center",
                borderRadius: "10px",
                backgroundColor: "red",
                color: "white"
              }}
              onClick={(e) => toggleFastQuote(e)}
            >
              X
            </button>

            <PublicQuoteCard theme="light" text="black" agents={[]} />
          </Modal>

          {formData.showIcons === true ? (
            <span>
              <div className="row no-gutters row-fixed" style={{ padding: "20px" }}>
                <div className="col-6 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4">
                  <button
                    className="box-shadow-button"
                    style={{
                      boxShadow: "0px 0px 2px 2px black",
                      borderRadius: "10px",
                      height: "100px",
                      width: "100%",
                      backgroundColor: "white"
                    }}
                    onClick={(e) => toggleFastQuote(e)}
                  >
                    <div className="row">
                      <div className="col-xl-12">
                        <img
                          alt="fawn-general"
                          style={{ height: "50px", width: "75px" }}
                          src="/images/paper_plane_PNG71.png"
                        />
                      </div>
                      <div className="col-xl-12">
                        <h5 style={{ color: "black" }}>
                          <strong>Auto and/or Home Quote</strong>
                        </h5>
                      </div>
                    </div>
                  </button>
                </div>

                <div className="col-6 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4">
                  <button
                    className="box-shadow-button"
                    style={{
                      boxShadow: "0px 0px 2px 2px black",
                      borderRadius: "10px",
                      height: "100px",
                      width: "100%",
                      backgroundColor: "red",
                      color: "white"
                    }}
                    onClick={() =>
                      redirect(
                        "https://cluballiance.aaa.com/insurance/ia?promo=FAWN&ian=Fawn%20Circle%20LLC"
                      )
                    }
                  >
                    <div className="row">
                      <div className="col-xl-12">
                        <img
                          alt="aaa-membership"
                          style={{ height: "50px", width: "75px" }}
                          src="/images/logos/aaa-logo.png"
                        />
                      </div>
                      <div className="col-xl-12">
                        <h5 style={{ color: "white" }}>
                          <strong>AAA Membership</strong>
                        </h5>
                      </div>
                    </div>
                  </button>
                </div>

                <div className="col-6 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4">
                  <button
                    style={{
                      boxShadow: "0px 0px 2px 2px black",
                      borderRadius: "10px",
                      height: "100px",
                      width: "100%",
                      backgroundColor: "white",
                      color: "black"
                    }}
                    onClick={() =>
                      redirect(
                        "https://neptuneflood.com/consumer-app/?source=Sa38oXQAsJxkbvhRezGuvCFvo2g9AVLhtYFeJG0IhfWyLEDSxnHdZo8Ci27%2FphyVSmM8UAUQ2KEM4ib%2Fkdf1%2BVCdZ07Vp79X9rP6g%2FrVh0E%3D"
                      )
                    }
                  >
                    <div className="row">
                      <div className="col-xl-12">
                        <img
                          alt="neptuneflood"
                          style={{ height: "50px", width: "75px" }}
                          src="/images/neptune-logo.svg"
                        />
                      </div>
                      <div className="col-xl-12">
                        <h5 style={{ color: "black" }}>
                          <strong>Flood Insurance Quote</strong>
                        </h5>
                      </div>
                    </div>
                  </button>
                </div>

                <div className="col-6 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4">
                  <button
                    style={{
                      boxShadow: "0px 0px 2px 2px black",
                      borderRadius: "10px",
                      height: "100px",
                      width: "100%",
                      backgroundColor: "#4ccbeb",
                      color: "black"
                    }}
                    onClick={() =>
                      redirect("https://coverpath.massmutual.com//?fg=Evan-Cleary-621160")
                    }
                  >
                    <div className="row">
                      <div className="col-xl-12">
                        <img
                          alt="massmutual-life-quote"
                          style={{ height: "60px", width: "60px" }}
                          src="/images/logos/massmutual-logo.jpg"
                        />
                      </div>
                      <div className="col-xl-12">
                        <h5 style={{ color: "#042d6c" }}>
                          <strong>Life Insurance Quote</strong>
                        </h5>
                      </div>
                    </div>
                  </button>
                </div>

                <div className="col-6 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4">
                  <button
                    style={{
                      boxShadow: "0px 0px 2px 2px black",
                      borderRadius: "10px",
                      height: "100px",
                      width: "100%",
                      backgroundColor: "#368ddf"
                    }}
                    onClick={() =>
                      redirect(
                        "https://track.nextinsurance.com/links?agent_affiliation=MItk8UCb86PK8XPT&serial=992855993&channel=affiliation"
                      )
                    }
                  >
                    <div className="row">
                      <div className="col-xl-12">
                        <i className="fa fa-cubes" aria-hidden="true"></i>
                      </div>
                      <div className="col-xl-12">
                        <h5 style={{ color: "white" }}>
                          <strong>Business Liability Quote</strong>
                        </h5>
                      </div>
                    </div>
                  </button>
                </div>

                <div className="col-6 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4">
                  <button
                    style={{
                      boxShadow: "0px 0px 2px 2px black",
                      borderRadius: "10px",
                      height: "100px",
                      width: "100%",
                      backgroundColor: "#f5f7f8",
                      color: "#258ccc"
                    }}
                    onClick={() =>
                      redirect("https://www.eventsured.com/partnership/fawn-circle-llc-2/")
                    }
                  >
                    <div className="row">
                      <div className="col-xl-12">
                        <img
                          alt="eventsured"
                          style={{ height: "50px", width: "50px" }}
                          src="/images/logos/es-logo.png"
                        />
                      </div>
                      <div className="col-xl-12">
                        <h5 style={{ color: "#258ccc" }}>
                          <strong>Special Events Quote</strong>
                        </h5>
                      </div>
                    </div>
                  </button>
                </div>

                <div className="col-6 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4">
                  <button
                    className="box-shadow-button"
                    style={{
                      backgroundColor: "#214D9B",
                      boxShadow: "0px 0px 2px 2px black",
                      borderRadius: "10px",
                      height: "100px",
                      width: "100%",
                      color: "white"
                    }}
                    onClick={() => redirect("https://nwexpress.com/fawncircle")}
                  >
                    <div className="row">
                      <div className="col-xl-12">
                        <img
                          alt="fawncircle"
                          style={{ height: "50px", width: "75px" }}
                          src="/images/nationwide-logo.png"
                        />
                      </div>
                      <div className="col-xl-12">
                        <h5 style={{ color: "white" }}>
                          <strong>Try Nationwide Express!</strong>
                        </h5>
                      </div>
                    </div>
                  </button>
                </div>

                <div className="col-6 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4">
                  <button
                    className="box-shadow-button"
                    style={{
                      boxShadow: "0px 0px 2px 2px black",
                      borderRadius: "10px",
                      height: "100px",
                      width: "100%",
                      backgroundColor: "orange",
                      color: "#3f7695"
                    }}
                    onClick={(e) => toggleTextQuote(e)}
                  >
                    <div className="row">
                      <div className="col-xl-12" style={{ padding: "0px 0px 0px 0px" }}>
                        <img
                          alt="plymouthrock"
                          style={{ height: "55px", width: "100px" }}
                          src="/images/plymouth-logo.png"
                        />
                      </div>
                      <div className="col-xl-12">
                        <h5 style={{ color: "black" }}>
                          <strong>Plymouth Rock Text Quote</strong>
                        </h5>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </span>
          ) : (
            <div className="row">
              <div className="col-lg-4 offset-lg-4" style={{ padding: "5px", textAlign: "center" }}>
                <button className="btn btn-light" onClick={() => returnToModule()}>
                  Return
                </button>
              </div>
            </div>
          )}

          <Modal
            isOpen={formData.showTextQuote}
            onRequestClose={(e) => toggleTextQuote(e)}
            style={customStylesModal}
          >
            <button
              style={{
                width: "12.5%",
                marginLeft: "87.5%",
                textAlign: "center",
                borderRadius: "10px",
                backgroundColor: "red",
                color: "white"
              }}
              onClick={(e) => toggleTextQuote(e)}
            >
              X
            </button>

            <TextToQuoteCard />
          </Modal>

          {formData.showCoverPathMass === true ? <CoverPathMass /> : null}
        </div>
      </div>
    </div>
  );
}

export default QuoteModule;
